export enum UserPermissionEnum {
  EDIT = 'edit',
  VIEW_ONLY = 'view only',
}

export enum Roles {
  ADMIN = 'admin',
  MSSP = 'mssp',
  SUPERENTITYLEADER = 'super entity leader',
  ENTITYLEADER = 'entity leader',
  SUBENTITYLEADER = 'subentity leader',
  PARTICPANT = 'participant',
}
export const rolePermissions = {
  [Roles.MSSP]: [
    Roles.PARTICPANT,
    Roles.ENTITYLEADER,
    Roles.SUBENTITYLEADER,
    Roles.MSSP,
    Roles.ADMIN,
    Roles.SUPERENTITYLEADER,
  ],
  [Roles.ADMIN]: [
    Roles.PARTICPANT,
    Roles.ENTITYLEADER,
    Roles.SUBENTITYLEADER,
    Roles.MSSP,
    Roles.ADMIN,
    Roles.SUPERENTITYLEADER,
  ],
  // Super Entity Leader mirrors MSSP on the FE, minus admin/mssp which it cannot manage.
  [Roles.SUPERENTITYLEADER]: [Roles.PARTICPANT, Roles.ENTITYLEADER, Roles.SUBENTITYLEADER, Roles.SUPERENTITYLEADER],
  [Roles.ENTITYLEADER]: [Roles.PARTICPANT, Roles.ENTITYLEADER, Roles.SUBENTITYLEADER],
  [Roles.SUBENTITYLEADER]: [Roles.PARTICPANT, Roles.SUBENTITYLEADER],
  [Roles.PARTICPANT]: [Roles.PARTICPANT],
};
